import React from 'react'
import DropDownFilter from './dropdown-filter'
import useHours from '../../../hooks/use-hours'
import { get } from 'lodash'

const HoursFilter = ({
    value = {},
    onChange = () => {},
    disabled
}) => {
    const [ hours ] = useHours()
    return (
        <React.Fragment>
            <DropDownFilter
                items={hours}
                title='Hours'
                onChange={hours => onChange({ ...value, hours })}
                values={get(value, 'hours', [])}
                disabled={disabled}
            />
        </React.Fragment>
    )
}

export default HoursFilter